import { render, staticRenderFns } from "./EmployeeDelete.vue?vue&type=template&id=3ec8c780&scoped=true&"
import script from "./EmployeeDelete.vue?vue&type=script&lang=js&"
export * from "./EmployeeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec8c780",
  null
  
)

export default component.exports